/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateNotificationAction } from './CreateNotificationAction';
import {
    CreateNotificationActionFromJSON,
    CreateNotificationActionFromJSONTyped,
    CreateNotificationActionToJSON,
} from './CreateNotificationAction';

/**
 * 
 * @export
 * @interface CreateNotification
 */
export interface CreateNotification {
    /**
     * 
     * @type {string}
     * @memberof CreateNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<CreateNotificationAction>}
     * @memberof CreateNotification
     */
    actions: Array<CreateNotificationAction>;
}

/**
 * Check if a given object implements the CreateNotification interface.
 */
export function instanceOfCreateNotification(value: object): value is CreateNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function CreateNotificationFromJSON(json: any): CreateNotification {
    return CreateNotificationFromJSONTyped(json, false);
}

export function CreateNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(CreateNotificationActionFromJSON)),
    };
}

export function CreateNotificationToJSON(value?: CreateNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(CreateNotificationActionToJSON)),
    };
}

